var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sidebar', { open: _vm.showSidebar }]},[_c('div',{staticClass:"sidebar-title"},[_vm._t("title")],2),_c('div',{staticClass:"sidebar-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }